import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import classNames from 'classnames';

import { ComputedResponseDtoSuiviDestructionSivEnum } from 'lib_api/lib/api/gen';

import { useDossierContext } from 'hooks/dossiers/DossierContext';
import { useUserStore } from 'hooks/UserStoreContext';
import {
  LABEL_DONNEE_EXPIREE,
  LABEL_IMMAT_MANQUANTE,
  LABEL_SANS_PLAQUE,
} from 'utils/global';

import { SuiviVehiculeMainInfoDetail } from './SuiviVehiculeMainInfoDetail/SuiviVehiculeMainInfoDetail';
import { TraitementFacturation } from './TraiteEnFacturation';
import { buildStatutContent } from './utils';

import './SuiviVehiculeMainInfo.less';

interface SuiviVehiculeMainInfoProps {
  additionalClassName?: string;
}

export const SuiviVehiculeMainInfo = ({
  additionalClassName,
}: SuiviVehiculeMainInfoProps): React.ReactElement => {
  const navigate = useNavigate();
  const user = useUserStore();
  const [{ result: dossier }] = useDossierContext();

  const isDetruitSiv =
    dossier.computed?.suiviDestructionSiv ===
    ComputedResponseDtoSuiviDestructionSivEnum.DETRUIT_APRES_SORTIE;

  return (
    <div className={classNames('suiviContainer', additionalClassName)}>
      <Button
        className="return-button"
        icon={<ArrowLeftOutlined />}
        onClick={(): void => navigate(-1)}
        type="default"
        shape="round"
        size="middle"
      >
        {'Retour'}
      </Button>
      <SuiviVehiculeMainInfoDetail label="Véhicule :">
        <span className="immatriculation">
          {dossier.body?.anonymise ? (
            <>{LABEL_DONNEE_EXPIREE}</>
          ) : (
            <>
              {dossier.body?.ficheVehicule?.immatriculation?.sansPlaque
                ? LABEL_SANS_PLAQUE
                : dossier.body?.ficheVehicule?.immatriculation?.numero ||
                  LABEL_IMMAT_MANQUANTE}
              {dossier.body?.ficheVehicule?.immatriculation
                ?.numeroImmatriculationVisible
                ? ' [ ' +
                  dossier.body?.ficheVehicule?.immatriculation
                    ?.numeroImmatriculationVisible +
                  ' ]'
                : ''}
            </>
          )}
        </span>
      </SuiviVehiculeMainInfoDetail>

      <SuiviVehiculeMainInfoDetail label="Statut :">
        <span className="status">{buildStatutContent(dossier)}</span>
      </SuiviVehiculeMainInfoDetail>

      <SuiviVehiculeMainInfoDetail label="Détruit dans le SIV :">
        <span className="status">{isDetruitSiv ? 'Oui' : 'Non'}</span>
      </SuiviVehiculeMainInfoDetail>

      <TraitementFacturation dossier={dossier} profile={user.profile} />
    </div>
  );
};
